var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMale(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#FF9900"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.0562 30.4438C28.4271 31.6895 30.075 32.3124 32 32.3124C33.925 32.3124 35.5729 31.6895 36.9437 30.4438C38.3146 29.1981 39 27.7006 39 25.9513V20.3854C39.0012 19.7238 38.7462 19.1609 38.2352 18.6965C37.7242 18.2322 37.1042 18 36.375 18C35.9387 18 35.5233 18.0928 35.129 18.2783C34.7347 18.4638 34.4208 18.7289 34.1875 19.0734C33.9565 18.7289 33.6432 18.4638 33.2477 18.2783C32.8522 18.0928 32.4363 18 32 18C31.5637 18 31.1483 18.0928 30.754 18.2783C30.3597 18.4638 30.0458 18.7289 29.8125 19.0734C29.5803 18.7289 29.2671 18.4638 28.8727 18.2783C28.4784 18.0928 28.0625 18 27.625 18C26.897 18.0011 26.2775 18.2332 25.7665 18.6965C25.2555 19.1598 25 19.7228 25 20.3854V25.9513C25 27.7006 25.6854 29.1981 27.0562 30.4438Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 46V41.5473C18 40.6461 18.2555 39.8181 18.7665 39.0633C19.2775 38.3084 19.9553 37.7317 20.8 37.3331C22.6083 36.5114 24.4458 35.8955 26.3125 35.4852C28.1792 35.0749 30.075 34.8692 32 34.8682C33.925 34.8671 35.8208 35.0728 37.6875 35.4852C39.5542 35.8976 41.3917 36.5135 43.2 37.3331C44.0458 37.7306 44.7242 38.3074 45.2352 39.0633C45.7462 39.8192 46.0012 40.6472 46 41.5473V46H18Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMale);
export default __webpack_public_path__ + "static/media/Male.8c93fd50779231c0eb963585c45763f7.svg";
export { ForwardRef as ReactComponent };